import * as Yup from 'yup';

export const updateVendorSchema = Yup.object().shape({
  name: Yup.string().nullable(true).required('Nama Perusahaan wajib diisi'),
  code: Yup.string().nullable(true).required('Kode Perusahaan wajib diisi'),
  category: Yup.mixed().nullable(true).required('Kategori Perusahaan wajib diisi'),
  type: Yup.mixed().nullable(true).required('Jenis Perusahaan wajib diisi'),
  division: Yup.mixed().nullable(true).required('Divisi Perusahaan wajib diisi'),
  email: Yup.string().email("Email tidak valid").nullable(true).required('Email Perusahaan wajib diisi'),
  phone: Yup.string().nullable(true).required('Nomor Telepon/WA wajib diisi'),
});